<script>
export default {
    data () { 
        return {
            deveEsconder: true
        }
    },
    created () {
        document.body.addEventListener('click', (e) => {
            
            // e.stopPropagation()

            // Label do Boostrap que mascara o input
            if (/label/i.test(e.target.nodeName)) {
                // Pega checkbox pelo for do label
                const input = document.getElementById(e.target.getAttribute('for'))
                
                if (input && /checkbox/i.test(input.type)) {
                    this.deveEsconder = false
                }
            
            } else {
                this.deveEsconder = !(/checkbox/i.test(e.target.type))
            }
        })
    },
    methods: {
        manterDropdownAberto (bvEvent) {
            
            if (this.deveEsconder == undefined) {
                return
            }

            if (!this.deveEsconder) {
                bvEvent.preventDefault()
                this.deveEsconder = true
                return
            } 
        }
    }
}
</script>